import {useHistory} from "react-router-dom";
import {useSelector} from "react-redux";
import {loadings} from "../../store/store";
import {useMainTranslation} from "../../../../../newShared/hooks/useMainTranslationHooks/useMainTranslation";
import {useSetBreadcrumbs} from "../../../../barsEnvironment/breadcrumbs/hooks/useBreadcrumbs";
import {PATH_LOCAL_ASSET_MANAGEMENT} from "../../../../../newShared/constants";
import {
    PATH_LOCAL_ASSET_MANAGEMENT_SOFTWARE,
    PATH_LOCAL_ASSET_MANAGEMENT_SOFTWARE_SETTINGS,
    PATH_LOCAL_ASSET_MANAGEMENT_SOFTWARE_SETTINGS_EXACT,
} from "../../constants";
import {TSoftwareAssetSettingsId} from "../../types";


export const useSoftwareAssetSettings = () => {
    const {t: tMenu} = useMainTranslation('', {keyPrefix: 'LeftMenu'});
    const history = useHistory();
    const {isLoadingSettings} = useSelector(loadings);

    useSetBreadcrumbs([
        {
            title: tMenu('Asset Management'),
            path: PATH_LOCAL_ASSET_MANAGEMENT
        },
        {
            title: 'Software',
            path: PATH_LOCAL_ASSET_MANAGEMENT_SOFTWARE
        },
        {
            title: 'Settings',
            path: PATH_LOCAL_ASSET_MANAGEMENT_SOFTWARE_SETTINGS
        },
    ]);

    const handleGoToSettingById = (id: TSoftwareAssetSettingsId) => {
        history.push(PATH_LOCAL_ASSET_MANAGEMENT_SOFTWARE_SETTINGS_EXACT.replace(':id', id));
    }

    const handleGoBack = () => {
        history.push(PATH_LOCAL_ASSET_MANAGEMENT_SOFTWARE);
    }

    return {
       handleGoBack,
       isLoadingSettings,
       handleGoToSettingById
    }

}
